import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-pinboard',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Pinboard icon</title><path d="M13.352 14.585l-4.509 4.614.72-4.062L3.428 7.57 0 7.753 7.58 0v2.953l7.214 6.646 4.513-1.105-4.689 4.982L24 24l-10.648-9.415z"/></svg>`,
    styles: []
})
export class SimpleIconsPinboardComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#0000FF';
    @Input() className: string = 'simple-icons-pinboard'
    constructor() {}
    ngOnInit(): void {}
}
